export const defaultParsingStep = {
  property: '',
  operator: {label: 'Equals', value: '==='},
  value: ''
}